module.exports = __webpack_public_path__ + "static/media/2n.6850c702.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/2n.svg
// module id = 155
// module chunks = 0